import { render, staticRenderFns } from "./DomainTld.vue?vue&type=template&id=47234104&"
import script from "./DomainTld.vue?vue&type=script&lang=js&"
export * from "./DomainTld.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports